var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 11,
    viewBox: "0 0 234 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 234,
    height: 11,
    rx: 5.5,
    fill: "#E1E1E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 117,
    height: 11,
    rx: 5.5,
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModerate);
export default __webpack_public_path__ + "static/media/moderate.70621bacb9d64d5351b7528a4722d316.svg";
export { ForwardRef as ReactComponent };